export const columns = [
  {
    field: "Id",
    headerName: "Id",
    flex: 1,
    minWidth: 90,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    minWidth: 120,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "product",
    headerName: "Product",
    flex: 1,
    minWidth: 200,
    sortable: true,
    type: "string",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "amount",
    headerName: "Denomination",
    flex: 1,
    minWidth: 100,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
   {
    field: "quantity",
    headerName: "Qty",
    flex: 1,
    minWidth: 70,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "discount",
    headerName: "Discount",
    flex: 1,
    minWidth: 100,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cashback",
    headerName: "Cashback",
    flex: 1,
    minWidth: 100,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "youpay",
    headerName: "You Pay",
    flex: 1,
    minWidth: 100,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "orderStatus",
    headerName: "Status",
    flex: 1,
    minWidth: 120,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
];
